// src/layouts/MainLayout.js
import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SideNav from '../components/SideNav';

function MainLayout({ children }) {
  return (
    <>
      <Header />
      <div className="d-flex">
        <SideNav />
        <main className="flex-grow-1 ">{children}</main>
      </div>
      <Footer />
    </>
  );
}

export default MainLayout;
